<div *ngIf="loaderService.isLoading | async" id="pause" class="d-flex align-items-center justify-content-center">
    <div id="spinner"></div>
</div>
<div class="modal-header bg-primary">
    <h4 class="modal-title"  style="color: white;"><b>{{eAppRegConstant.PageHeader}}</b>
        <br />Address Selection</h4>
  </div>
  <div class="modal-body">
    <!-- <p>{{cModalBody}}</p> -->
  <!---==============================================================================
        HEADER
    ===============================================================================--->
    <div id="fuzzymatch">
        <div class="row">
            <div class="col-md-12 ">
                <p>
                    We were unable to locate your business address in our Geographic Information System database.  
                    The addresses below are approximations of your business address.  If an address below is correct, 
                    please check the corresponding Match Found? checkbox and click the Accept and Proceed button.  
                    <!-- If none of the addresses below are correct, simply click Accept and Proceed. -->
                <p>
            </div>
        </div>
        <!-- <form [formGroup]="fForm"> -->
            <div class="row">
                <div class="col-md-12 table-responsive">
                        <table class="table table-bordered"  style="width: 100%;">
                            <thead style="text-align:center">
                                <tr class="colHd1">
                                    <th>S.No</th>
                                    <th>Address</th>
                                    <th>City</th>
                                    <th>State</th>
                                    <th>Zip Code</th>
                                    <th>Zip 4</th>
                                    <th>Match Found?</th>
                                </tr>
                            </thead>
                            <tbody style="text-align:center">
                                <tr *ngFor="let tRCFuzzyMatch of tRCFuzzyMatches; let i = index">
                                    <td>{{i+1}}</td>
                                    <td>{{tRCFuzzyMatch.stdAddress}}</td>
                                    <td>{{tRCFuzzyMatch.city}}</td>
                                    <td >{{tRCFuzzyMatch.state}}</td>
                                    <td >{{tRCFuzzyMatch.zip}}</td>
                                    <td >{{tRCFuzzyMatch.zip4}}</td>
                                    <td > <input [value]='i' type="radio" name="address" [(ngModel)]="selectedAddr"></td>
                                </tr>
                            </tbody>
                        </table>
                        <br />
                </div>
            </div>
        <!-- </form> -->
    </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="cancel()">Cancel</button> &nbsp;
      <button type="button" class="btn btn-primary" (click)="proceed()">Accept and Proceed</button>
    </div>
    

